<template>
  <div>
    <loading v-if="load" text="Por favor aguarde" fullscrean="true"/>
    <div class="home-page" v-else>
      <div class="container home-page__container">
        <section class="home-hero">
          <div class="home-hero__glow"></div>
          <div class="home-hero__brand">
            <div class="home-hero__logo-shell">
              <img src="../assets/logo.png" alt="Congregação Cristã no Brasil" class="img-fluid home-hero__logo">
            </div>
            <div class="home-hero__copy">
              <div class="home-hero__eyebrow">Bem-vindo ao CRS</div>
              <h1 class="home-hero__title">Escolha sua regional</h1>
              <p class="home-hero__subtitle">Acesse o calendário e listas da sua regional.</p>
            </div>
          </div>

          <div class="home-hero__search">
            <div class="home-hero__search-field">
              <i class="fa-solid fa-magnifying-glass home-hero__search-icon" aria-hidden="true"></i>
              <input
                id="regional-search"
                v-model="termo"
                type="search"
                class="form-control home-hero__input"
                placeholder="Buscar regional"
                @input="pesquisar()"
              >
            </div>
          </div>

          <div class="home-selector__head">
            <div>
              <div class="home-selector__eyebrow" v-if="pesquisou">Regionais disponíveis</div>
              <h2 class="home-selector__title">{{ pesquisou ? 'Selecione sua regional' : 'Selecione seu estado' }}</h2>
              <p class="home-selector__subtitle">
                {{ pesquisou ? 'Escolha a regional desejada para acessar o calendário.' : 'Comece pelo seu estado para ver as regionais disponíveis.' }}
              </p>
            </div>
            <button class="btn btn-outline-primary home-selector__back" v-if="pesquisou" @click="pesquisar(true)">
              <i class="fa-solid fa-arrow-left mr-2" aria-hidden="true"></i>Voltar
            </button>
          </div>

          <div class="home-selector__grid" v-if="!pesquisou">
            <button
              class="home-selector__item"
              @click="selecionarEstado(e)"
              v-for="e in estados"
              :key="e.sigla_estado"
            >
              <span class="home-selector__item-code">{{ e.sigla_estado }}</span>
              <span class="home-selector__item-copy">
                <span class="home-selector__item-title">{{ e.nome_estado }}</span>
                <span class="home-selector__item-subtitle">{{ e.regionais.length }} {{ e.regionais.length === 1 ? 'regional disponível' : 'regionais disponíveis' }}</span>
              </span>
              <i class="fa-solid fa-chevron-right home-selector__item-arrow" aria-hidden="true"></i>
            </button>
          </div>

          <div class="home-selector__grid home-selector__grid--regional" v-else>
            <button
              class="home-selector__item home-selector__item--regional"
              @click="selecionar(r)"
              v-for="r in search"
              :key="r.id_regional"
            >
              <span class="home-selector__item-code">{{ r.sigla_estado }}</span>
              <span class="home-selector__item-copy">
                <span class="home-selector__item-title">{{ r.nome_regional }}</span>
                <span class="home-selector__item-subtitle">Regional {{ r.sigla_estado }}</span>
              </span>
              <i class="fa-solid fa-arrow-up-right-from-square home-selector__item-arrow" aria-hidden="true"></i>
            </button>
          </div>

          <div class="alert alert-info home-selector__empty" v-if="pesquisou && !search.length">
            Nenhuma regional encontrada para a busca atual. Tente outro nome ou volte para selecionar pelo estado.
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "@/components/Loading";
  export default {
    name: 'Home',
    components: {Loading},
    data() {
      return {
        load: true,
        termo: '',
        search: [],
        anoAtual: new Date().getFullYear(),
        regionais: [],
        estados: [],
        pesquisou: null
      }
    },

    methods: {
      normalizarTexto(texto) {
        return (texto || '')
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim();
      },

      getRegionais() {
        this.load = true;
        const url = 'app/regional';

        this.$http.get(url)
          .then(response => {
            this.load = false;
            this.regionais = response.data || [];
            localStorage.setItem(url, JSON.stringify(this.regionais));
            this.preencherEstados();

          }, res => {
            const data = localStorage.getItem(url);
            console.log(data)

            if (data) {
              this.regionais = JSON.parse(data);
              this.preencherEstados();

            } else {
              this.$router.push('/offline');
            }

            this.load = false;
          });
      },

      preencherEstados() {
        const estados = {};
        const estadosBrasil = {
          "AC": "Acre",
          "AL": "Alagoas",
          "AP": "Amapá",
          "AM": "Amazonas",
          "BA": "Bahia",
          "CE": "Ceará",
          "DF": "Distrito Federal",
          "ES": "Espírito Santo",
          "GO": "Goiás",
          "MA": "Maranhão",
          "MT": "Mato Grosso",
          "MS": "Mato Grosso do Sul",
          "MG": "Minas Gerais",
          "PA": "Pará",
          "PB": "Paraíba",
          "PR": "Paraná",
          "PE": "Pernambuco",
          "PI": "Piauí",
          "RJ": "Rio de Janeiro",
          "RN": "Rio Grande do Norte",
          "RS": "Rio Grande do Sul",
          "RO": "Rondônia",
          "RR": "Roraima",
          "SC": "Santa Catarina",
          "SP": "São Paulo",
          "SE": "Sergipe",
          "TO": "Tocantins"
        };

        this.regionais.forEach(r => {
          if (!estados[r.sigla_estado]) {
            estados[r.sigla_estado] = {
              nome_estado: estadosBrasil[r.sigla_estado] || "Desconhecido",
              sigla_estado: r.sigla_estado,
              regionais: []
            };
          }

          estados[r.sigla_estado].regionais.push(r);
        });

        this.estados = Object.values(estados).sort((a, b) => b.regionais.length - a.regionais.length);
      },

      pesquisar(clear) {
        if (clear) {
          this.termo = null;
        }

        const termo = this.termo ? this.normalizarTexto(this.termo) : null;
        this.pesquisou = !!termo;
        this.search = termo
          ? this.regionais.filter(r => this.normalizarTexto(r.nome_regional).includes(termo))
          : this.regionais;
      },

      selecionarEstado(estado) {
        this.termo = '';
        this.pesquisou = true;
        this.search = this.regionais.filter(r => r.sigla_estado === estado.sigla_estado);
      },

      selecionar(r) {
        this.$store.commit('setDataUser', { ...this.user, id_regional: r.id_regional });
        window.location.href = sessionStorage.getItem('redirect') || '/calendario';
      }
    },

    mounted() {
      if (this.user.id_regional) {
        this.$router.push('/calendario');

      } else {
        this.getRegionais();
      }
    },

    computed: {
      user() {
        return this.$store.state.user
      }
    },
  }
</script>
<style scoped>
.home-page {
  min-height: 100vh;
  background-color: var(--bg-theme);
}

.home-page__container {
  min-height: 100vh;
  padding-top: 32px;
  padding-bottom: 48px;
  max-width: 600px;
}

.home-hero {
  position: relative;
  margin-bottom: 24px;
}

.home-hero__glow {
  position: absolute;
  inset: 14px 8% auto;
  height: 220px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(30, 51, 108, 0.1) 0%, rgba(30, 51, 108, 0) 68%);
  filter: blur(8px);
  pointer-events: none;
}

.home-hero__brand {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 22px;
}

.home-hero__copy {
  text-align: center;
}

.home-hero__logo-shell {
  flex: 0 0 auto;
  width: 92px;
  height: 92px;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, rgba(30, 51, 108, 0.1) 0%, rgba(251, 163, 1, 0.12) 100%);
  border: 1px solid rgba(30, 51, 108, 0.08);
}

.home-hero__logo {
  max-width: 62px;
}

.home-hero__eyebrow {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--secondary);
  margin-bottom: 4px;
}

.home-hero__title {
  margin: 0 0 4px;
  color: var(--text-strong);
  font-size: 2rem;
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.home-hero__subtitle {
  margin: 0;
  color: var(--text-theme-secondary);
  max-width: 580px;
  line-height: 1.5;
}

.home-hero__search {
  margin-bottom: 24px;
}

.home-hero__search-field {
  position: relative;
}

.home-hero__search-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-theme-secondary);
  font-size: 16px;
}

.home-hero__input {
  padding-left: 48px;
  min-height: 56px;
  border-radius: 18px;
}

.home-selector__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.home-selector__eyebrow {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-theme-secondary);
}

.home-selector__title {
  margin: 0 0 6px;
  color: var(--text-strong);
  font-size: 1.45rem;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.home-selector__subtitle {
  margin: 0;
  color: var(--text-theme-secondary);
}

.home-selector__back {
  white-space: nowrap;
}

.home-selector__grid {
  display: grid;
  gap: 12px;
}

.home-selector__item {
  width: 100%;
  border: 1px solid var(--border-color);
  border-radius: 22px;
  background: linear-gradient(135deg, var(--bg-theme-secondary) 0%, rgba(255, 255, 255, 0.84) 100%);
  color: var(--text-theme);
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  text-align: left;
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease, background-color 0.16s ease;
}

.home-selector__item:hover,
.home-selector__item:focus {
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(20, 35, 70, 0.1);
  border-color: rgba(30, 51, 108, 0.18);
  outline: none;
}

.home-selector__item-code {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  background: linear-gradient(135deg, rgba(30, 51, 108, 0.12) 0%, rgba(251, 163, 1, 0.16) 100%);
  color: var(--primary);
}

.home-selector__item-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.home-selector__item-title {
  font-weight: 700;
  color: var(--text-strong);
}

.home-selector__item-subtitle {
  margin-top: 3px;
  font-size: 13px;
  color: var(--text-theme-secondary);
}

.home-selector__item-arrow {
  margin-left: auto;
  color: var(--text-theme-secondary);
}

.home-selector__empty {
  margin-top: 16px;
}

.dark-mode .home-hero__logo {
  filter: invert(100%);
}

.dark-mode .home-hero__logo-shell,
.dark-mode .home-selector__item {
  border-color: rgba(124, 181, 230, 0.12);
}

.dark-mode .home-selector__item {
  background: linear-gradient(135deg, rgba(29, 42, 60, 0.92) 0%, rgba(36, 50, 70, 0.82) 100%);
}

@media (min-width: 768px) {
  .home-hero__copy {
    text-align: left;
  }
}

@media (max-width: 767px) {
  .home-page__container {
    padding-top: 18px;
    padding-bottom: 28px;
  }

  .home-hero__brand,
  .home-selector__head {
    flex-direction: column;
  }

  .home-hero__title {
    font-size: 1.7rem;
  }
}
</style>
